import { useTranslation } from 'react-i18next';
import { allSettled } from 'effector';
import { useUnit } from 'effector-react';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { $error, clearError } from '../../models/error';
import { createScope } from '../../models/model';

export const ErrorMessage = ({ id }: { id: string }) => {
  const { t } = useTranslation();
  const [error] = useUnit([$error]);

  const scope = createScope(id);

  const handleError = async () => {
    await allSettled(clearError, { scope });
  };

  return (
    <Dialog onClose={handleError} open={!!error}>
      <DialogTitle>{t('Error')}</DialogTitle>

      <DialogContent>
        <DialogContentText>{error?.message ?? t('DataLoadingError')}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleError}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
